const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? ''
  : 'http://localhost:8000';

export const getSetLists = async () => {
  const response = await fetch(`${API_BASE_URL}/api/setlists`);
  if (!response.ok) {
    throw new Error('Failed to fetch setlists');
  }
  return response.json();
};

export const getSetList = async (id) => {
  const response = await fetch(`${API_BASE_URL}/api/setlists/${id}`);
  if (!response.ok) {
    throw new Error('Failed to fetch setlist');
  }
  return response.json();
};

export const createSetList = async (setlistData) => {
  const response = await fetch(`${API_BASE_URL}/api/setlists`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(setlistData),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || `Failed to create setlist (${response.status})`);
  }
  return response.json();
};

export const updateSetList = async (id, setlistData) => {
  const response = await fetch(`${API_BASE_URL}/api/setlists/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(setlistData),
  });
  if (!response.ok) {
    throw new Error('Failed to update setlist');
  }
  return response.json();
};

export const deleteSetList = async (id) => {
  const response = await fetch(`${API_BASE_URL}/api/setlists/${id}`, {
    method: 'DELETE',
  });
  if (!response.ok) {
    throw new Error('Failed to delete setlist');
  }
  return response.json();
};